<template>
  <div class="DataViews">
    <v-row class="DataViews__filter-row">
      <v-col>
        <v-btn text small color="primary" @click="isAddDataViewOpen = true">
          + Add Data View
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      class="DataViews__data-table elevation-0 clickable"
      outlined
      item-key="id"
      :item-class="() => 'DataViews__data-table-row'"
      :items="dataViews"
      :headers="headers"
      @click:row="handleGoToDataView"
      :loading="dataViewsLoading"
    >
    </v-data-table>

    <create-data-view :dialog="isAddDataViewOpen" @close="isAddDataViewOpen = false" />
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import CreateDataView from '@/views/data-views/create-data-view/create-data-view-modal.vue';

const {
  mapGetters: dataViewGetters,
  mapActions: dataViewActions,
} = createNamespacedHelpers('DataView');

export default {
  name: 'DataViews',
  components: { CreateDataView },
  data() {
    return {
      isAddDataViewOpen: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Updated At',
          value: 'updatedAt',
        }
      ],
    };
  },
  watch: {
    'selectedCustomer.customer_id'() {

    },
  },
  computed: {
    ...dataViewGetters({
      dataViews: 'DATA_VIEWS',
      dataViewsLoading: 'DATA_VIEW_LOADING',
    })
  },
  async mounted() {
    await this.getDataViews();
  },
  methods: {
    ...dataViewActions(['getDataViews']),
    handleGoToDataView(item) {
      this.$router.push({ path: `/data-views/${item.id}` });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'data-views';
</style>
